
<template>
    <div class="personalBox">
        <div class="personalTop">
            <i class="icon icon_logo" @click="goHomePage()"></i>
            <a href="http://www.aiyechen.com" target="_blank" title="野尘出品" class="ycCopyright">➲ 野尘出品</a>
            <el-button plain class="editPwd" @click="isEditPwd=true">修改密码</el-button>
        </div>
        <div class="personalInfo">
            <div class="infoLeft">
                <ul>
                    <li class="liActive">
                        <i class="icon icon_personal"></i>个人中心
                    </li>
                </ul>
            </div>
            <div class="infoRight">
                <ul>
                    <li class="img">
                        <i class="icon icon_img"></i>
                    </li>
                    <li>
                        <div class="left">用户名：</div>
                        <div class="right">
                            {{ userInfo.userName }}
                        </div>
                    </li>
                    <li>
                        <div class="left">姓名：</div>
                        <div class="right">
                            <el-input
                                placeholder="请输入姓名"
                                v-model="userInfo1.realName"
                                :disabled="isFlag==1?false:true"
                                :autofocus="isFlag==1"
                                @blur="saveUserInfo()">
                            </el-input>
                            <i class="icon el-icon-edit-outline" @click="isFlag=1"></i>
                        </div>
                    </li>
                    <li>
                        <div class="left">手机：</div>
                        <div class="right">
                            <el-input
                                placeholder="请输入手机号"
                                v-model="userInfo1.phoneNum"
                                :disabled="isFlag==2?false:true"
                                :autofocus="isFlag==2"
                                @blur="saveUserInfo()"
                                >
                            </el-input>
                            <i class="icon el-icon-edit-outline" @click="isFlag=2" ></i>
                        </div>
                    </li>
                    <li v-if="userInfo.position&&userInfo.position!=''">
                        <div class="left">职务：</div>
                        <div class="right">
                            <el-input
                                placeholder="请输入职务"
                                v-model="userInfo1.position"
                                :disabled="isFlag==3?false:true"
                                :autofocus="isFlag==3"
                                @blur="saveUserInfo()">
                            </el-input>
                            <i class="icon el-icon-edit-outline" @click="isFlag=3"></i>
                        </div>
                    </li>
                    <li v-if="userInfo.companyName&&userInfo.companyName!=''">
                        <div class="left">公司名：</div>
                        <div class="right">
                             {{ userInfo.companyName }}
                        </div>
                    </li>
                    <li v-if="userInfo.accountMgr&&userInfo.accountMgr!=''">
                        <div class="left">客户经理：</div>
                        <div class="right">
                             {{ userInfo.accountMgr }}
                        </div>
                    </li>
                    <li v-if="userInfo.accMgrPhone&&userInfo.accMgrPhone!=''">
                        <div class="left">客户经理电话：</div>
                        <div class="right">
                             {{ userInfo.accMgrPhone }}
                        </div>
                    </li>
                </ul>
                <div class="bottom">
                    <span class="top"></span>
                    ※ 提示：忘记密码请与您的客户经理联系！
                </div>
                <div class="logOut">
                    <el-button @click="logOut()" class="exitBtn" title="退出登录">退出登录</el-button>
                </div>
            </div>
        </div>
        <el-dialog
            title="修改密码"
            custom-class="editPwdDialog"
            :visible.sync="isEditPwd"
            center>
            <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
                <el-form-item label="用户名" >
                    <div style="padding-left:20px;">{{ userInfo.userName }}</div>
                </el-form-item>
                <el-form-item label="旧密码" prop="passOld">
                    <el-input type="password" v-model="ruleForm2.passOld" autocomplete="off" placeholder="请输入旧密码"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="passNew">
                    <el-input type="password" v-model="ruleForm2.passNew" autocomplete="off" placeholder="请输入新密码"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="checkPass">
                    <el-input type="password" v-model="ruleForm2.checkPass" autocomplete="off" placeholder="请输入确认密码"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="saveUserInfo('ruleForm2')">确定</el-button>
                    <el-button @click="resetForm('ruleForm2')">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import Utils from '../utils/utils.js'
    import SStorage from '../utils/SStorage.js'
  export default {
    name: 'personalBox',
    data() {
        var validatePass0 = (rule, value, callback) => {
            if (value === '' || value == this.ruleForm2.passNew) {
                callback(new Error('请输入旧密码'));
            }else {
                callback();
            }
        };
        var validatePass1 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入新密码'));
            } else {
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入确认密码'));
            } else if (value !== this.ruleForm2.passNew) {
                callback(new Error('两次输入密码不一致'));
            } else {
                callback();
            }
        };
        return {
            userInfo1:{},
            isFlag:"",
            isEditPwd: false,
            ruleForm2: {
                passNew: '',
                checkPass: '',
                passOld: '',
                logOut: ''
            },
            rules2: {
                passOld: [
                    { validator: validatePass0, trigger: 'blur' }
                ],
                passNew: [
                    { validator: validatePass1, trigger: 'blur' }
                ],
                checkPass: [
                    { validator: validatePass2, trigger: 'blur' }
                ],
            }
        }
    },
    computed:{...mapState(['indexSearchInfo','productRouterInfo','userInfo'])},
    created(){
        this.userInfo1 = this.userInfo
    },
    methods: {
        //编辑用户信息后提交 /  提交修改的密码
        saveUserInfo(flag){
            let params = {};
            params.id = this.userInfo1.id
            this.isFlag = ''
            if( !flag ){
                params.realName = this.userInfo1.realName||''
                params.phoneNum = this.userInfo1.phoneNum||''
                params.position = this.userInfo1.position||''
                if( params.phoneNum.trim()!=''&&!Utils.mobileCheck(params.phoneNum) ){
                    this.userInfo1.phoneNum = this.userInfo.phoneNum||''
                    this.$message({
                        message:'请输入正确的手机号',
                        type:'error',
                        center:true,
                        showClose:false
                    })
                    return;
                }
            }else{
                let that = this ,flag1 = true;
                this.$refs[flag].validate((valid) => {
                    if (valid) {
                        params.oldPw = that.ruleForm2.passOld
                        params.newPw = that.ruleForm2.passNew
                    } else {
                        flag1 = false
                        return false;
                    }
                });
                if( !flag1 ){
                    return;
                }
            }
            params.realName = this.userInfo1.realName
            this.$store.dispatch('updateUserInfo',params).then( res => {
                if( res.data.retCode == '000'){
                    this.$store.dispatch('userInfo',res.data.data);
                    this.userInfo1 = res.data.data;
                    SStorage.setItem('userInfo',res.data.data);
                    this.isEditPwd = false;
                    this.ruleForm2 =  {
                            passNew: '',
                            checkPass: '',
                            passOld: '',
                            logOut: ''
                    }
                     this.$message({
                        message:'您的信息修改成功',
                        type:'success',
                        center:true,
                        showClose:false
                    })
                }else{
                    this.$message({
                        message:res.data.retMsg,
                        type:'error',
                        center:true,
                        showClose:false
                    })
                }
            })
        },
        //取消修改密码
        resetForm(formName){
            this.$refs[formName].resetFields();
            this.isEditPwd = false
            this.ruleForm2 = {
                passNew: '',
                checkPass: '',
                passOld: ''
            }
        },
        //返回首页
        goHomePage(){
            this.$router.push({
                path:'/dashBoard'
            })
        },
        logOut() {
            let that = this;
            this.$store.dispatch('logout').then( res => {
                if( res.data.retCode == '000'){
                    SStorage.clear();
                    that.$router.push({
                        path:'/login'
                    })
                }
            })
           
        }
    },
    mounted() {
      
    }
  }
</script>

<style lang="scss" src="../sass/personal.scss" scope></style>




// WEBPACK FOOTER //
// src/view/personal.vue